import styled from "styled-components";
import theme from "../../../../../styles/theme";
import { Page } from "../../../../../components/page-base";

export const Wrapper = styled(Page.Root)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 24px;
  background: #f8f9fa;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  max-width: 720px;
  width: 100%;
  box-shadow: 0 6px 24px rgba(18, 38, 63, 0.06);
  text-align: center;
`;

export const IconWrapper = styled.div`
  color: ${theme.colors.blue.primary};
  svg {
    font-size: 64px;
  }
  margin-bottom: 16px;
`;

export const Title = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  color: #202124;
  margin: 8px 0 12px;
`;

export const Subtitle = styled.p`
  font-family: "Roboto", sans-serif;
  color: #5f6368;
  margin-bottom: 24px;
`;

export const StyledButton = styled.button`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: white;
  background-color: #4285f4;
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #3367d6;
  }
`;
export const BtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vw;
  place-self: center;
  @media (${theme.devices.tablet}) {
    display: flex;
    flex-direction: column;
    row-gap: 1vh;
    flex: none;
  }
`;
